// extracted by mini-css-extract-plugin
module.exports = {"global":"global_global__3579B"};